<div class="sms-registration">
	<div class="success-icon">
		<mat-icon class="custom-icon" svgIcon="verify_email"></mat-icon>
	  <h3 class="greeting mb-5">{{'MSG.VERIFY_MAIL' | translate}}</h3>

	</div>
	<div class="content">
    <span>{{ 'MSG.DESCRIPTION' | translate}}</span><br>
		<span>{{'MSG.MAIL_DESC'| translate }}</span> <strong class="accent">{{email}}</strong> <br>
	</div>
	<!-- <button mat-flat-button class="resend-email" color="accent" (click)="resendVerifyMail()">Re-send confirmation email</button> -->
	<div class="alert">
		<!-- <p class="lt">{{'MSG.DONT_HAVE_ACC' | translate}} <a class="accent" routerLink="/auth/register">{{'LABEL.REGISTER_HERE' | translate}}</a></p> -->
		<p class="lt">{{'MSG.HAVE_ACC' | translate}} <a class="accent" routerLink="/auth/login">{{'LABEL.LOGIN' | translate}}</a></p>
	</div>
</div>
